/**
 * @description 公共的逻辑处理
 */
import {
  getToken,
  getUserInfoByToken,
  refreshIocBasicToken,
  getFileUrls,
  getYcToken,
  getYcUserInfo,
  getUserCompany,
  getProjectDetail,
  getCompanyAddress,
  getAllProjects,
  getProjects
} from '@/api/commonApi';
import store from '@/store';

// 通过code获取accessToken
export const getTokenService = async ({ code, appId }) => {
  // 参数不全就不调用接口
  if (!code || !appId) {
    return Promise.reject('缺少参数 code|appId');
  }
  try {
    const params = {
      grantType: 'authorization_code',
      appId,
      code,
    };
    const res = await getToken(params);
    console.log('getToken', res);
    store.commit('setToken', res.data?.accessToken || '');
    store.commit('setTokenInfo', res.data);
    store.commit('setTokenStartTime', new Date().getTime());
    return Promise.resolve(res.data.accessToken);
  } catch (error) {
    console.warn('获取token异常', error);
    return Promise.reject(false);
  }
};

// 获取用户信息
export const getUserInfo = async accessToken => {
  if (!accessToken) return Promise.reject(false);
  try {
    // const params = {
    //   accessToken,
    // };
    const res = await getUserInfoByToken();
    console.log('getUserInfoByToken', res);
    store.commit('setUserInfo', res.data || {});
    return Promise.resolve(res.data);
  } catch (error) {
    console.warn('获取getUserInfo异常', error);
    return Promise.reject(false);
  }
};

// 刷新ioc底座token
export const refreshTokenHandler = async refreshToken => {
  try {
    if (!refreshToken) return;
    const params = {
      refreshToken,
    };
    const res = await refreshIocBasicToken(params);
    console.log('refresh token', res);
    store.commit('setToken', res.data?.accessToken || '');
    store.commit('setTokenInfo', res.data);
    store.commit('setTokenStartTime', new Date().getTime());
    return Promise.resolve(true);
  } catch (error) {
    console.warn('获取token异常', error);
    return Promise.reject(false);
  }
};

// 获取项目信息
export const getProjectDetailHandler = async () => {
  try {
    const params = {
      projectCode: store.getters['parkCode'],
    };
    const res = await getProjectDetail(params);
    console.log('getProjectDetail', res);
    return Promise.resolve(res?.data);
  } catch (error) {
    console.warn('获取token异常', error);
    return Promise.reject(false);
  }
};

// 通过code获取云城的accessToken
export const getYcTokenService = async ({ code, appid, secret }) => {
  // 参数不全就不调用接口
  if (!code || !secret || !appid) {
    return Promise.reject('缺少参数 code|secret|channelId');
  }
  try {
    const params = {
      grant_type: 'authorization_code',
      appid,
      secret,
      code,
    };
    const res = await getYcToken(params);
    console.log('getToken', res);
    store.commit('setYcToken', res.data.access_token || '');
    return Promise.resolve(res.data.access_token);
  } catch (error) {
    console.warn('获取云城token异常', error);
    return Promise.reject(false);
  }
};

// 获取云城用户信息
export const getYcUserInfoService = async accessToken => {
  if (!accessToken) return Promise.reject(false);
  try {
    const params = {
      access_token: accessToken,
    };
    const res = await getYcUserInfo(params);
    console.log('getYcUserInfo', res);
    store.commit('setYcUserInfo', res.data || {});
    return Promise.resolve(res);
  } catch (error) {
    console.warn('获取云城getUserInfo异常', error);
    return Promise.reject(false);
  }
};

/**
 * @description 批量获取文件url
 * * @param {*} fileIdList 文件id组成的数组
 *
 */
export const getFileUrlBatch = async fileIdList => {
  try {
    if (!fileIdList || !fileIdList.length) return [];
    const domainUrl = sessionStorage.getItem('domainUrl');
    if(domainUrl){
      return fileIdList.map(i=>({
        id:i,
        url:domainUrl + i,
        fileName:i,
        fileLink:domainUrl + i
      }))
    }
    const params = {
      fileNames: fileIdList.join(','),
    };
    const { data } = await getFileUrls(params);
    return fileIdList.reduce((previous, currentFileId) => {
      const targetData = data.find(i => i.fileName === currentFileId);
      previous.push({ ...targetData, url: targetData.fileLink, id: targetData.fileName });
      return previous;
    }, []);
  } catch (error) {
    console.error('批量获取文件url异常', error);
  }
};

/**
 * @description 获取用户已认证的企业数据
 *
 */
export const getUserAuthCompanyList = async (data={}) => {
  try {
    const params = {
      pageNum: 1,
      pageSize: 1000,
      ...data
    };
    const res = await getUserCompany(params);
    const list = res.data?.records || [];
    return list.map(i => ({
      ...i,
      companyId: i.id,
      companyName: i.name,
    }));
  } catch (error) {
    console.error('获取认证的企业数据异常', error);
    return [];
  }
};
/**
 * @description 获取项目数据
 *
 */
export const getProjectList = async () => {
  try {
    const res = await getProjects();
    const list = res.data || [];
    return list.map(l=>{
      return {
        projectCode:l.projectCode,
        projectName:l.projectName
      }
    });
  } catch (error) {
    console.error('获取项目数据异常', error);
    return [];
  }
};
export const getAllProjectList = async (params={}) => {
  try {
    const res = await getAllProjects(params);
    const list = res.data || [];
    return list.map(l=>{
      return {
        projectCode:l.projectCode,
        projectName:l.projectName
      }
    });
  } catch (error) {
    console.error('获取项目数据异常', error);
    return [];
  }
};


/**
 * @description 获取企业地址
 *
 */
export const getCompanyAddressList = async companyId => {
  try {
    const params = {
      companyId,
      pageNum: 1,
      pageSize: 1000,
    };
    const res = await getCompanyAddress(params);
    const list = res.data?.records || [];
    return list.map(i => ({
      ...i,
      address: `${i.projectName || ''}|${i.fullName}`,
    }));
  } catch (error) {
    console.error('获取企业地址数据异常', error);
    return [];
  }
};
